// Dependencies
import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

// Store
import { homeStoreSelectors } from "../../../store/store";
import { User } from "../../../../auth/reducers/users.reducer";
import { HomeActionCreators } from "../../../actions/actionCreators";
import { ActionCreator } from "../../../../../actions/actions";

// Components
import UserAvatar from "./UserAvatar/UserAvatar.component";
import {
    checkPermission,
    isAdmin
} from "../../../../../utils/Authorization/authorization";

// Styles
import "./LoggedInUser.component.scss";

export interface LoggedInUserProps {
    userInfo: User;
    getUserInfo: ActionCreator;
    logout: ActionCreator;
    setShowNotifications: any;
}

export interface LoggedInUserState {
    showUserMenu: boolean;
    showNotifications: boolean;
}

class LoggedInUser extends Component<LoggedInUserProps, LoggedInUserState> {
    constructor(props) {
        super(props);

        this.state = {
            showNotifications: false,
            showUserMenu: false
        };
    }

    logout = () => {
        this.props.logout();
    };

    handleClickUserMenu = () => {
        this.setState({
            showUserMenu: true
        });
    };

    handleClickNotificationsMenu = () => {
        this.setState({
            showNotifications: true
        });
    };

    handleClickOutsideMenus = event => {
        if (document.querySelector(`.user-button`) && !document.querySelector(`.user-button`).contains(event.target)) {
            this.setState({
                showUserMenu: false
            });
        }

        if (
            !document
                .querySelector(`.notifications-button`)
                .contains(event.target)
        ) {
            this.setState({
                showNotifications: false
            });
        }
    };

    componentDidMount() {
        this.props.getUserInfo();
        document.addEventListener("click", this.handleClickOutsideMenus);
    }

    componentWillUnmount() {
        document.removeEventListener("click", this.handleClickOutsideMenus);
    }

    render() {
        const renderUserInfo = this.props.userInfo ? (
            <div className="logged-in-info">
                <div style={{display:'none'}}>

                    <button
                        className="notifications-button"
                        onClick={this.handleClickNotificationsMenu}
                    >
                        <i className="icon-bell-solid"></i>
                    </button>
                    {this.state.showNotifications && (
                        <div className="notifications-list">
                            <div className="empty"> No new notifcations</div>
                        </div>
                    )}
                </div>
                <div>
                    <button
                        className="user-button"
                        onClick={this.handleClickUserMenu}
                    >
                        <span className="logged-in-email">
                            {this.props.userInfo.first_name +
                                " " +
                                this.props.userInfo.last_name}
                        </span>
                        <i className="icon-caret-down-solid"></i>
                    </button>
                    {this.state.showUserMenu && (
                        <div className="user-menu">
                            <div className="header">
                                {this.props.userInfo.profile_picture_base64 && this.props.userInfo.profile_picture_base64 !== '' ? (
                                    <img
                                        alt={this.props.userInfo.email}
                                        src={this.props.userInfo.profile_picture_base64.includes('data:image/png;base64')
                                            ? `${this.props.userInfo.profile_picture_base64}`
                                            : `data:image;base64,${this.props.userInfo.profile_picture_base64}`}
                                    />
                                ) : (
                                    <UserAvatar
                                        email={this.props.userInfo.email}
                                        size={36}
                                    />
                                )}
                                <div className="user-info">
                                    <p>
                                        {this.props.userInfo.first_name +
                                            " " +
                                            this.props.userInfo.last_name}
                                    </p>
                                    <span>{this.props.userInfo.email}</span>
                                </div>
                            </div>
                            <div className="user-options">
                                <ul>
                                    <li className="">
                                        <i className="icon-user-circle-light" />
                                        <Link to="/user/profile/">
                                            Edit Profile
                                        </Link>
                                    </li>
                                    {isAdmin() && (
                                        <li>
                                            <i className="icon-tag-light" />
                                            <Link to="/roles">
                                                Roles Management
                                            </Link>
                                        </li>
                                    )}
                                    {isAdmin() && (
                                        <li>
                                            <i className="icon-users-light" />
                                            <Link to="/users">
                                                Users Management
                                            </Link>
                                        </li>
                                    )}

                                    {checkPermission("activity_history") && (
                                        <li>
                                            <i className="icon-history-light" />
                                            <Link to="/history/activity">
                                                Activity History
                                            </Link>
                                        </li>
                                    )}

                                    <li
                                        className="logout"
                                        onClick={this.logout}
                                    >
                                        <i className="icon-sign-out-light" />
                                        Sign Out
                                    </li>
                                </ul>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        ) : (
            <div className="logged-in-loading">Loading user info...</div>
        );

        return (
            <div id="LoggedInUser">
                <div className="logged-in-user-box">
                    <div className="logged-in-user-content">
                        {renderUserInfo}
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    userInfo: homeStoreSelectors.userInfo(state)
});

const mapDispatchToProps = {
    getUserInfo: HomeActionCreators.getUserInfo,
    logout: HomeActionCreators.logout
};

export default connect(mapStateToProps, mapDispatchToProps)(LoggedInUser);
